import { SAVE_DOCUMENT_STATUS, SAVE_USER_DETAIL,  SAVE_LOAN, SAVE_LOAN_IN_STATUS,SAVE_LOAN_ID, SAVE_WITHDRAW_LOAN_STATUS } from "../../Redux/types";

const userDetail = (state = {}, action) => {
  switch (action.type) {
    case SAVE_USER_DETAIL:
      return {
        ...state,
        user_detail: action.payload.data,
      };
      /* istanbul ignore next */
    case SAVE_DOCUMENT_STATUS:
      return {
        ...state,
        document_status: action.payload
      }
      case SAVE_LOAN_ID:
        // console.log(action.payload)
        return {
            ...state,
            loanId: action.payload.loan_id
        }
      case SAVE_LOAN:
        return {
          ...state,
          loanDetail: action.payload,
        }; 
       case SAVE_LOAN_IN_STATUS:
        return {
          ...state,
          loanStatusInDetail: action.payload,
        };
        case SAVE_WITHDRAW_LOAN_STATUS:
          return {
            ...state,
            withdrawLoanDetail: action.payload,
          };  
    default:
      return state;
  }
};

export default userDetail;
